import type { JSXElement } from "solid-js"

export default function EmSmallTextMuted (text : JSXElement) {
  return <em class="small text-muted">{text}</em>
}
